import type { RequestData } from '@ant-design/pro-components';
import { request } from '@umijs/max';
import type { SortOrder } from 'antd/es/table/interface';
import { BASE_URL } from './config';

/** 获取配置项 GET /robot/data/config/key/{configKey} */
export async function getConfig(key: string) {
  return request<API.BaseResponse>(`/robot/data/config/key/${key}`, {
    method: 'GET',
  });
}

/** 获取数据字典 GET /robot/data/dict/list/{dictName} */
export async function getDataDict(name: API.DataDictType) {
  return request<API.CommonResponse<API.DataDict[]>>(
    `/robot/data/dict/list/${name}`,
    {
      method: 'GET',
    },
  ).then((res) => res.data);
}

/** 获取通知消息列表 GET /robot/event/notice/listAll */
export function getNotificationList(
  data: API.PageParams & API.NOTIFICATION.NotificationSearch = {
    pageNum: 1,
    pageSize: 1000,
  },
) {
  return request<API.ListResponse<API.EVENT.Event>>(
    '/robot/event/notice/listAll',
    {
      method: 'GET',
      params: data,
    },
  );
}
export function updateNotificationAllRead() {
  return request<API.BaseResponse>('robot/event/notice/handle', {
    method: 'PUT',
  });
}

// sse stream
export async function streamRequest<T>(
  url: string | URL | Request,
  data: T,
  options: RequestInit = {},
) {
  const token = window.localStorage.getItem('token');
  return fetch(BASE_URL + url, {
    method: 'POST',
    body: JSON.stringify(data),
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
}

// helper
export function transformListDataForProTable<T, P>(
  query: (params: API.PageParams & P) => Promise<API.ListResponse<T>>,
  params: P & {
    pageSize?: number;
    current?: number;
    keyword?: string;
  },
  sort: Record<string, SortOrder> = {},
): Promise<RequestData<T>> {
  const { current, pageSize, keyword, ...rest } = params;
  const newSort = Object.keys(sort).reduce<Record<string, string>>(
    (acc, key) => {
      if (sort[key])
        acc[key] = sort[key].endsWith('end')
          ? sort[key].replace('end', '')
          : sort[key];
      return acc;
    },
    {},
  );
  const newPramas: API.PageParams & P = {
    ...(rest as P),
    pageNum: current,
    pageSize,
    ...newSort,
  };
  console.log('[API] Table Data Query:', newPramas, sort);
  return query(newPramas).then((res) => {
    if (res.code === 200) {
      return {
        success: true,
        total: res.total,
        data: res.rows,
      };
    }
    return {
      success: false,
      total: 0,
      data: [],
    };
  });
}
